import React, { useState } from 'react';
import { iconSportCssClass } from '../data/utils/iconSportCssClass';
import { usePrematchData } from '../prematch/PrematchDataProvider';

export default function MatchHeader(props) {
    const prematchData = usePrematchData();
    const [toggled, setToggled] = useState(props.toggled);
    
    function handleToggle() {
        setToggled(!toggled);
    }
    
    const match = props.match;
    const sport = prematchData.sportById[match.sportRef];
    const country = sport.categoryById[match.categoryRef];
    const desc = `${sport.descrizione} - ${country.descrizione} | ${match.dateShort != null ? match.dateShort : match.date}`;

    const icoSport = iconSportCssClass(sport.id, sport.iconClass);

    return (
        <>
            <div className="l_3_3 landing__matchHeader-wrapper">
                <div className={`l_3_3_1 ${icoSport}`}></div>
                <div className={`l_3_3_1 ${country.categoryIcon}`}></div>
                <span>{desc}</span>
            </div>
            {toggled && props.children}
        </>
    );
}